import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { QtyComponent } from './qty.component';

@NgModule({
  declarations: [
    QtyComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [QtyComponent]
})
export class QtyModule { }
